// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.receipt-container {
    padding: 5%;
    /* background-color: #ffffff; */
    font-size: 14px;
}

.receipt-container .logo {
    height: 40px;
}

table,
th,
td {
    border: 1px solid black;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInJlY2VpcHQuY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtJQUNJLFdBQVc7SUFDWCwrQkFBK0I7SUFDL0IsZUFBZTtBQUNuQjs7QUFFQTtJQUNJLFlBQVk7QUFDaEI7O0FBRUE7OztJQUdJLHVCQUF1QjtBQUMzQiIsImZpbGUiOiJyZWNlaXB0LmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyIucmVjZWlwdC1jb250YWluZXIge1xuICAgIHBhZGRpbmc6IDUlO1xuICAgIC8qIGJhY2tncm91bmQtY29sb3I6ICNmZmZmZmY7ICovXG4gICAgZm9udC1zaXplOiAxNHB4O1xufVxuXG4ucmVjZWlwdC1jb250YWluZXIgLmxvZ28ge1xuICAgIGhlaWdodDogNDBweDtcbn1cblxudGFibGUsXG50aCxcbnRkIHtcbiAgICBib3JkZXI6IDFweCBzb2xpZCBibGFjaztcbn0iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/receipt/receipt.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;;;IAGI,uBAAuB;AAC3B;AACA,4mBAA4mB","sourcesContent":[".receipt-container {\n    padding: 5%;\n    /* background-color: #ffffff; */\n    font-size: 14px;\n}\n\n.receipt-container .logo {\n    height: 40px;\n}\n\ntable,\nth,\ntd {\n    border: 1px solid black;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
